import Cookie from 'js-cookie';

const tagManagerId = 'GTM-TP65PS';
const cookiePrefix = 'ga_conversion_';

class GoogleTagManager {
    constructor({ env }) {
        this._isProduction = env.isProduction;
        this._active = env.isProduction || (localStorage && localStorage.tagManagerEnabled);
        this.init();
    }

    init() {
        this.checkConversionCookies();

        // If GTM is not activated on the environment we still want to handle cookies
        // for debugging purposes and so they don't pile up.
        if (!this._active) {
            this.removeNewParameter();
            return;
        }

        // If tag manager already loaded, do nothing.
        if (document.getElementById('tagManager')) {
            return;
        }

        this.addTagManager();
        // we want to make sure that GA is loaded before doing anything on the page
        let interval = setInterval(() => {
            if (window.ga) {
                if (!this._isProduction) {
                    console.log(new Date().toISOString() + ': GTM Loaded');
                }
                this.removeNewParameter();
                clearInterval(interval);
            }
        }, 500);
    }

    // Adds the tag manager script to the beginning of the <head>
    addTagManager() {
        let script = document.createElement('script');
        script.id = 'tagManager';
        script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${tagManagerId}');
        `;
        document.head.prepend(script);
    }

    // Checks cookies for conversion data and fire events.
    checkConversionCookies() {
        let cookies = Cookie.get();
        Object.keys(cookies).forEach(name => {
            if (name.indexOf(cookiePrefix) !== 0) {
                return;
            }

            let orderId = name.substr(cookiePrefix.length);

            this.fireEvent({ 'event': 'orderPlaced' });

            try {
                let orderInfo = JSON.parse(atob(cookies[name]));
                orderInfo = this.sanitizeOrderInfo(orderInfo);
                this.fireEvent(orderInfo);
            } catch (e) {
                console.error(new Date().toISOString() + `: Conversion cookie for order ${orderId} could not be decoded.`, {
                    cookie: cookies[name],
                });
            }

            Cookie.remove(name);
        });
    }

    // Removes new=1 from url while leaving other parameters intact.
    removeNewParameter() {
        setTimeout(() => {
            if (!window.location.href.split('?')[1]) {
                return;
            }
            if (!window.history.replaceState) {
                return;
            }
            // remove the hash
            let currentUrl = window.location.href.split('#')[0];
            let newUrl = currentUrl.split('?')[0] + '?' + currentUrl
                .split('?')[1].split('&').filter((paramString) => {
                    return paramString !== 'new=1';
                }).join('&');

            if (newUrl.slice(-1) === '?') {
                newUrl = newUrl.substr(0, newUrl.length - 1);
            }

            // add back the hash
            if (window.location.hash) {
                newUrl += window.location.hash;
            }

            window.history.pushState({}, null, newUrl);
        }, 5000);
    }

    fireEvent(eventData) {
        if (!this._isProduction) {
            console.log(new Date().toISOString() + ': Adding event to datalayer: ', eventData);
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventData);
    }

    sanitizeOrderInfo(orderInfo) {
        if (orderInfo.transactionTotal) {
            orderInfo.transactionTotal = Number(orderInfo.transactionTotal);
        }
        if (orderInfo.transactionTax) {
            orderInfo.transactionTax = Number(orderInfo.transactionTax);
        }
        if (orderInfo.transactionProducts) {
            orderInfo.transactionProducts.forEach(product => {
                if (product.price) {
                    product.price = Number(product.price);
                }
            });
        }
        return orderInfo;
    }
}

export default (nuxt) => new GoogleTagManager(nuxt);
